// @flow
import { FormBuilderContext } from 'pages/Contexts/FormBuilderContext'
import * as React from 'react'

type Props = { children: Function }

function FormBuilderSettingsCompletePageFormConsumer({
  children,
}: Props): React.Node {
  const {
    setExtraContexts,
    completePage,
    setCompletePage,
    setIsDirty,
    isSavingForm,
    isFetchingForm,
  } = React.useContext(FormBuilderContext)

  return children({
    setExtraContexts,
    completePage,
    setCompletePage: (data) => {
      setCompletePage(data)
      setIsDirty(true)
    },
    isLoading: isSavingForm || isFetchingForm,
  })
}

export default FormBuilderSettingsCompletePageFormConsumer
